import { Checkbox, Link } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import {
  BookOpen as BookOpenIcon,
  Edit as EditIcon,
  Mic as MicIcon,
  PenTool as PenToolIcon,
  Speaker as SpeakerIcon,
  Trash2 as DeleteIcon,
} from 'react-feather'
import CustomTooltip from 'src/components/common/customTooltip'

import { statusRenderer } from './columnRenders'
import {
  NotificationCategoryList,
  NotificationTagGroupList,
  NotificationTargetGroupList,
} from './constants'
import { getFileUrl } from './helpers'

// const difficultyLevelMapper = {
//   continueLearning: 'Continue Learning',
//   absoluteBeginners: 'Absolute Beginners',
//   beginner: 'Beginner',
//   intermidiate: 'Intermediate',
//   advanced: 'Advanced',
//   fluent: 'Fluent',
//   interestingStuff: 'Interesting Stuff',
//   allLevels: 'All Levels',
// }

const statusGetter = row => {
  return row?.isActive === false || row?.isActive === 'false'
    ? 'InActive'
    : 'Active'
}

export const StatusCell = ({ value }) => {
  const isActive = value === "Active";
  return (
    <span
      style={{
        display: "inline-block",
        padding: "4px 8px",
        borderRadius: "6px",
        backgroundColor: isActive ? "#d4edda" : "#f8d7da",
        color: isActive ? "#155724" : "#721c24",
        fontWeight: 600,
        fontSize: "14px",
        textAlign: "center",
        minWidth: "70px",
      }}
    >
      {value}
    </span>
  );
};

// const videosGetter = row => {
//   return row?.videos?.length
// }
const courseGetter = row => row.course?.name
export const LinkGetter = (name, id, path) => {
  if (!name) {
    return <p>N/A</p>;
  }
  return (
    <CustomTooltip title={`Update ${name}`}>
      <Link
        href={`/app/${path}?_id=${id}`}
        className="text-blue-600 underline"
      >
        {name}
      </Link>
    </CustomTooltip>
  )
};
const unitGetter = row => row.unit?.name
const chapterGetter = row => row.chapter?.name
const lessonGetter = row => row.lesson?.name
const createdAtGetter = row => moment(row?.createdAt).format('DD/MM/YYYY')
// const difficultyLevelGetter = ({row}) =>
//   difficultyLevelMapper[row.difficultyLevel]
const createUserName = ({ row }) => `${row?.username}`
const dateTimeGetter = ({ row }) =>
  moment(row?.createdAt).format('DD/MM/YYYY HH:mm:ss A')
const lastLoginGetter = ({ row }) =>
  moment(row?.lastLogin).format('DD/MM/YYYY HH:mm:ss A')
const linkRenderer = (url, onClick) =>
  url ? <Link onClick={() => onClick(url)} sx={{ cursor: 'pointer' }}>Link</Link> : <p>N/A</p>

export const ThumbnailCell = ({ value, alt, onClick }) => {
  if (!value) return <p>N/A</p>;
  return (
    <img
      src={getFileUrl(value)}
      alt={alt}
      onClick={onClick}
      style={{
        width: '80px',
        height: '50px',
        borderRadius: '6px',
        objectFit: 'cover',
        cursor: onClick ? 'pointer' : 'default',
      }}
    />
  );
};
const capitalizeText = ({ row }) =>
  row['issueType'].charAt(0).toUpperCase() + row['issueType'].slice(1)

const notificationCategoryList = ({ row }) =>
  NotificationCategoryList.filter(item => item.key === row.category)[0]?.[
  'value'
  ]

const notificationTargetGroupList = ({ row }) =>
  NotificationTargetGroupList.filter(item => item.key === row.targetGroup)[0]?.[
  'value'
  ]
const notificationTagGroupListRender = ({ row }) =>
  NotificationTagGroupList.filter(item => item.key === row.tag)[0]?.['value']

const usernameRenderer = ({ row }) => row.user.name
const categoryIconRenderer = record => {
  let categoryIconToReturn
  switch (record.row.category) {
    case 'Listening':
      categoryIconToReturn = <MicIcon />
      break
    case 'Reading':
      categoryIconToReturn = <BookOpenIcon />
      break
    case 'Writing':
      categoryIconToReturn = <PenToolIcon />
      break
    case 'Speaking':
      categoryIconToReturn = <SpeakerIcon />
      break
    default:
      categoryIconToReturn = <BookOpenIcon />
      break
  }
  return categoryIconToReturn
}

const actionRenderer = (record, onEditRow, onDeleteRow) => (
  <>
    <Link onClick={() => onEditRow(record.row)}>
      <EditIcon />
    </Link>
    <Link onClick={() => onDeleteRow(record.id)}>
      <DeleteIcon />
    </Link>
  </>
)
const actionRendererWithoutDelete = (record, onEditRow) => (
  <>
    <Link onClick={() => onEditRow(record.row)}>
      <EditIcon />
    </Link>
  </>
)
const deleteRenderer = (record, onDeleteRow) => (
  <Link onClick={() => onDeleteRow(record.id)}>
    <DeleteIcon />
  </Link>
)

const GetCourseTableColumns = () => [
  {
    accessorKey: 'name',
    header: 'Language',
    width: 160,
  },
  // {
  //   field: 'description',
  //   headerName: 'Description',
  //   width: 200,
  // },
  // {
  //   field: 'category',
  //   headerName: 'Category',
  //   //type: "number",
  //   width: 150,
  //   //editable: true,
  // },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 200,
  },
  // {
  //   accessorKey: 'difficultyLevel',
  //   header: 'Difficulty Level',
  //   width: 180,
  //   valueGetter: difficultyLevelGetter
  // },
  // {
  //   accessorKey: 'videos',
  //   header: 'Video',
  //   width: 130,
  //   renderCell: cellValues => linkRenderer(cellValues.row.video, onMediaClick),
  // },
  // {
  //     accessorKey: "image",
  //     header: "Image",
  //     width: 130,
  //     renderCell: (cellValues) =>
  //         linkRenderer(cellValues.row.image, onMediaClick),
  // },
  // {
  //     accessorKey: "whatYouWillLearn",
  //     header: "What You Will Learn",
  //     width: 200,
  // },
  {
    accessorKey: 'isActive',
    header: 'Status',
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 160,
    accessorFn: createdAtGetter,
  },
  // {
  //   accessorKey: 'Actions',
  //   width: 200,
  //   renderCell: cellValues =>
  //     actionRenderer(cellValues, onEditRow, onDeleteRow),
  // },
]

const GetBannerTableColumns = () => [
  {
    accessorKey: 'heading',
    header: 'Heading',
    width: 150,
  },
  {
    accessorKey: 'subtext',
    header: 'Sub text',
    width: 150,
  },
  {
    accessorKey: 'course',
    header: 'Language',
    width: 150,
    exportValue: row => row?.course?.name,
    cell: ({ row }) => LinkGetter(row?.original?.course?.name, row?.original?.course?._id, "languages"),
  },
  {
    accessorKey: 'imageUrl',
    header: 'Desktop Banner',
    width: 150,
    cell: ({ getValue }) => {
      const url = getValue();
      return (
        <img
          src={getFileUrl(url)}
          alt="desktop banner"
          style={{ width: "120px", height: "50px", borderRadius: "6px" }}
        />
      );
    },
  },
  {
    accessorKey: 'mobileImageUrl',
    header: 'Mobile Banner',
    width: 150,
    cell: ({ getValue }) => {
      const url = getValue();
      return (
        <img
          src={getFileUrl(url)}
          alt="desktop banner"
          style={{ width: "auto", height: "50px", borderRadius: "6px" }}
        />
      );
    },
  },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 200,
  },
  {
    accessorKey: 'isActive',
    header: 'Status',
    width: 150,
    accessorFn: statusRenderer,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
]

const GetUnitTableColumns = (onMediaClick, onEditRow, onDeleteRow) => [
  {
    accessorKey: 'nameX',
    header: 'Language',
    width: 130,
    exportValue: courseGetter,
    cell: ({ row }) => LinkGetter(row?.original?.course?.name, row?.original?.course?._id, "languages"),
  },
  {
    accessorKey: 'name',
    header: 'Course',
    width: 350,
  },
  {
    accessorKey: 'videoThumbnail',
    header: 'Thumbnail',
    width: 120,
    cell: ({ getValue }) => {
      const value = getValue()
      return (
        <ThumbnailCell
          value={value}
          alt="course thumbnail"
          onClick={value ? () => onMediaClick(getFileUrl(value)) : undefined}
        />
      )
    },
  },
  {
    accessorKey: 'courseDetailsThumbnail',
    header: 'Course Details Thumbnail',
    width: 120,
    cell: ({ getValue }) => {
      const value = getValue()
      return (
        <ThumbnailCell
          value={value}
          alt="course details thumbnail"
          onClick={value ? () => onMediaClick(getFileUrl(value)) : undefined}
        />
      )
    },
  },
  {
    accessorKey: 'video',
    header: 'Video',
    width: 100,
    cell: ({ getValue }) => linkRenderer(getValue(), url => onMediaClick(getFileUrl(url))),
  },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 150,
  },
  {
    accessorKey: 'isActiveX',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]
const GetChapterTableColumns = () => [
  {
    accessorKey: 'nameX',
    header: 'Language',
    width: 130,
    exportValue: courseGetter,
    cell: ({ row }) => LinkGetter(row?.original?.course?.name, row?.original?.course?._id, "languages"),
  },
  {
    accessorKey: 'nameXX',
    header: 'Course',
    width: 250,
    accessorFn: unitGetter,
    cell: ({ row }) => LinkGetter(row?.original?.unit?.name, row?.original?.unit?._id, "courses"),
  },
  {
    accessorKey: 'name',
    header: 'Chapter',
    width: 250,
  },
  {
    accessorKey: 'description',
    header: 'Description',
    width: 300,
  },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 110,
  },
  {
    accessorKey: 'isActiveX',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]
const GetLessonTableColumns = (onMediaClick, onEditRow, onDeleteRow) => [
  // {
  //   accessorKey: 'Actions',
  //   width: 150,
  //   renderCell: cellValues =>
  //     actionRenderer(cellValues, onEditRow, onDeleteRow),
  // },
  {
    header: 'Language',
    width: 110,
    exportValue: courseGetter,
    cell: ({ row }) => LinkGetter(row?.original?.course?.name, row?.original?.course?._id, "languages"),
  },
  {
    header: 'Course',
    width: 150,
    exportValue: unitGetter,
    cell: ({ row }) => LinkGetter(row?.original?.unit?.name, row?.original?.unit?._id, "courses"),
  },
  {
    header: 'Chapter',
    width: 150,
    exportValue: chapterGetter,
    cell: ({ row }) => LinkGetter(row?.original?.chapter?.name, row?.original?.chapter?._id, "chapters"),
  },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 110,
  },
  {
    accessorKey: 'name',
    header: 'Lesson',
    width: 250,
  },
  {
    accessorKey: 'description',
    header: 'Description',
    width: 300,
  },
  {
    accessorKey: 'videoThumbnail',
    header: 'Thumbnail',
    width: 120,
    cell: ({ getValue }) => {
      const value = getValue()
      return (
        <ThumbnailCell
          value={value}
          alt="lesson thumbnail"
          onClick={value ? () => onMediaClick(getFileUrl(value)) : undefined}
        />
      )
    },
  },
  {
    accessorKey: 'video',
    header: 'Video',
    width: 100,
    cell: ({ getValue }) => linkRenderer(getValue(), url => onMediaClick(getFileUrl(url))),
  },
  {
    field: 'isActive',
    header: 'Status',
    width: 150,
    accessorFn: statusRenderer,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  // {
  //   field: 'createdAt',
  //   header: 'Created On',
  //   width: 180,
  //   valueGetter: createdAtGetter,
  // },
]
const GetLessonVideoTableColumns = (onMediaClick, onEditRow, onDeleteRow) => [
  {
    accessorKey: 'categoryX',
    header: 'Category',
    width: 150,
    exportValue: row => row?.category?.name,
    cell: ({ row }) => LinkGetter(row?.original?.category?.name, row?.original?.category?._id, "videoCategories"),
  },
  {
    accessorKey: 'name',
    header: 'Name',
    width: 200,
  },
  {
    accessorKey: 'video',
    header: 'Url',
    width: 150,
    cell: ({ row }) => linkRenderer(row.original.video, onMediaClick),
  },
  {
    accessorKey: 'coin',
    header: 'Coin',
    width: 150,
  },
  {
    accessorKey: 'isActiveX',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]
const GetVideoCategoryColumns = () => [
  {
    accessorKey: 'name',
    header: 'Name',
    width: 200,
  },
  {
    accessorKey: 'title',
    header: 'Title',
    width: 150,
  },
  {
    accessorKey: 'sortOrder',
    header: 'Sort Order',
    width: 150,
  },
  {
    accessorKey: 'isActive',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  // {
  //   accessorKey: '',
  //   header: 'Videos',
  //   width: 150,
  //   accessorFn: videosGetter,
  // },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]
const GetLessonVocabularyTableColumns = (
  onMediaClick,
  onEditRow,
  onDeleteRow
) => [
    {
      field: 'nameX',
      headerName: 'Course',
      width: 150,
      valueGetter: courseGetter,
    },
    {
      field: 'nameXX',
      headerName: 'Unit',
      width: 150,
      valueGetter: unitGetter,
    },
    {
      field: 'nameXXX',
      headerName: 'Chapter',
      width: 150,
      valueGetter: chapterGetter,
    },
    {
      field: 'nameXXXX',
      headerName: 'Lesson',
      width: 150,
      valueGetter: lessonGetter,
    },
    {
      field: 'wordInNative',
      headerName: 'Native Word',
      width: 200,
    },
    {
      field: 'wordInRoman',
      headerName: 'Roman Word',
      width: 200,
    },
    {
      field: 'wordMeaningToDisplay',
      headerName: 'Word Meaning',
      width: 200,
    },
    {
      field: 'videoUrl',
      headerName: 'Url',
      width: 110,
      renderCell: cellValues => linkRenderer(cellValues.row.video, onMediaClick),
    },
    {
      field: 'coin',
      headerName: 'Coin',
      width: 120,
    },
    {
      field: 'isActiveX',
      headerName: 'Status',
      width: 150,
      valueGetter: statusGetter,
      cell: ({ getValue }) => <StatusCell value={getValue()} />,
    },
    {
      field: 'createdAtX',
      headerName: 'Created On',
      width: 150,
      valueGetter: createdAtGetter,
    },
    {
      field: 'Actions',
      width: 150,
      renderCell: cellValues =>
        actionRenderer(cellValues, onEditRow, onDeleteRow),
    },
  ]

const GetExerciseMasterTableColumns = () => [
  {
    accessorKey: 'nameX',
    header: 'Language',
    width: 150,
    exportValue: courseGetter,
    cell: ({ row }) => LinkGetter(row?.original?.course?.name, row?.original?.course?._id, "languages"),
  },
  {
    accessorKey: 'nameXX',
    header: 'Course',
    width: 150,
    exportValue: unitGetter,
    cell: ({ row }) => LinkGetter(row?.original?.unit?.name, row?.original?.unit?._id, "courses"),
  },
  {
    accessorKey: 'nameXXX',
    header: 'Chapter',
    width: 150,
    exportValue: chapterGetter,
    cell: ({ row }) => LinkGetter(row?.original?.chapter?.name, row?.original?.chapter?._id, "chapters"),
  },
  {
    accessorKey: 'nameXXXX',
    header: 'Lesson',
    width: 250,
    exportValue: lessonGetter,
    cell: ({ row }) => LinkGetter(row?.original?.lesson?.name, row?.original?.lesson?._id, "lessons"),
  },
  {
    accessorKey: 'name',
    header: 'Practice',
    width: 250,
  },
  {
    accessorKey: 'isActiveX',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAtX',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]

const GetExerciseDetailTableColumns = () => [
  {
    accessorKey: 'name',
    header: 'Name',
    width: 250,
  },
  {
    accessorKey: 'questionType',
    header: 'Type',
    width: 250,
  },
  {
    accessorKey: 'category',
    header: 'Category',
    width: 150,
    renderCell: cellValues => categoryIconRenderer(cellValues),
  },
  {
    accessorKey: 'question',
    header: 'Question',
    width: 250,
  },
  {
    accessorKey: 'isActive',
    header: 'Status',
    width: 150,
    accessorFn: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    accessorKey: 'createdAt',
    header: 'Created On',
    width: 180,
    accessorFn: createdAtGetter,
  },
]

function IndeterminateCheckbox({ indeterminate, className = '', ...rest }) {
  const ref = React.useRef(!null)
  React.useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return (
    <Checkbox sx={{ p: 0, m: 0 }} ref={ref} className={className + ' cursor-pointer'} {...rest} />
  )
}

const GetExerciseDetailSubSetColumns = () => [
  {
    id: 'select',
    header: ({ table }) => (
      <IndeterminateCheckbox
        {...{
          checked: table.getIsAllRowsSelected(),
          indeterminate: table.getIsSomeRowsSelected(),
          onChange: table.getToggleAllRowsSelectedHandler(),
        }}
      />
    ),
    width: 50,
    cell: ({ row }) => (
      <IndeterminateCheckbox
        {...{
          checked: row.getIsSelected(),
          indeterminate: row.getIsSomeSelected(),
          onChange: row.getToggleSelectedHandler(),
        }}
      />
    ),
  },
  {
    accessorKey: 'name',
    header: 'Practice Items',
    width: 200,
  },
  {
    accessorKey: 'question',
    header: 'Question',
    width: 200,
  },
]

const GetServiceLogColumns = onDeleteRow => [
  {
    field: 'message',
    headerName: 'Error Detail',
    width: 800,
  },
  {
    field: 'errorOrigin',
    headerName: 'Error Origin',
    width: 180,
  },
  {
    field: 'createdAtX',
    headerName: 'Created On',
    width: 180,
    valueGetter: dateTimeGetter,
  },
  {
    field: 'Actions',
    width: 150,
    renderCell: cellValues => deleteRenderer(cellValues, onDeleteRow),
  },
]

const GetUserTableColumns = (onEditRow, onDeleteRow) => [
  {
    field: 'userName',
    headerName: 'Name',
    width: 200,
    valueGetter: createUserName,
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'role',
    headerName: 'Role',
    width: 150,
  },
  {
    field: 'city',
    headerName: 'City',
    width: 150,
  },
  {
    field: 'isActive',
    headerName: 'Status',
    width: 150,
    valueGetter: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },
  {
    field: 'lastLogin',
    headerName: 'Last Login',
    width: 180,
    valueGetter: lastLoginGetter,
  },
  {
    field: 'lastVisitedPage',
    headerName: 'Last Visit',
    width: 150,
  },
  {
    field: 'createdAt',
    headerName: 'Created On',
    width: 180,
    valueGetter: createdAtGetter,
  },
  {
    field: 'Actions',
    width: 200,
    renderCell: cellValues =>
      actionRendererWithoutDelete(cellValues, onEditRow, onDeleteRow),
  },
]
const GetReportsColumns = (onEditRow, onDeleteRow) => [
  {
    field: 'userName',
    headerName: 'User',
    width: 150,
  },
  {
    field: 'userEmail',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'reportLocation',
    headerName: 'Location',
    width: 100,
  },
  {
    field: 'issueType',
    headerName: 'Issue Type',
    width: 180,
    valueGetter: capitalizeText,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    valueGetter: capitalizeText,
  },
  {
    field: 'comments',
    headerName: 'Comments',
    width: 500,
  },
  {
    field: 'createdAt',
    headerName: 'Created On',
    width: 180,
    valueGetter: dateTimeGetter,
  },
  {
    field: 'Actions',
    width: 150,
    renderCell: cellValues => deleteRenderer(cellValues, onDeleteRow),
  },
  {
    field: 'Actions',
    width: 200,
    renderCell: cellValues =>
      actionRenderer(cellValues, onEditRow, onDeleteRow),
  },
]
const GetNotificationsColumns = (onEditRow, onDeleteRow) => [
  {
    field: 'category',
    headerName: 'Category',
    width: 150,
    valueGetter: notificationCategoryList,
  },
  {
    field: 'targetGroup',
    headerName: 'Target Group',
    width: 200,
    valueGetter: notificationTargetGroupList,
  },
  {
    field: 'tag',
    headerName: 'Tag Group',
    width: 200,
    valueGetter: notificationTagGroupListRender,
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 180,
  },
  {
    field: 'message',
    headerName: 'Message',
    width: 380,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    valueGetter: statusGetter,
    cell: ({ getValue }) => <StatusCell value={getValue()} />,
  },

  {
    field: 'createdAt',
    headerName: 'Created On',
    width: 180,
    valueGetter: dateTimeGetter,
  },
  {
    field: 'Actions',
    width: 150,
    renderCell: cellValues => deleteRenderer(cellValues, onDeleteRow),
  },
  {
    field: 'Actions',
    width: 200,
    renderCell: cellValues =>
      actionRenderer(cellValues, onEditRow, onDeleteRow),
  },
]

const GetFeedbacksColumns = (onEditRow, onDeleteRow) => [
  {
    field: 'rating',
    headerName: 'Rating',
    width: 150,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    width: 200,
  },
  {
    field: 'submissionDate',
    headerName: 'Submission Date',
    width: 180,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
  },
  {
    field: 'user',
    headerName: 'Username',
    width: 150,
    valueGetter: usernameRenderer,
  },
  {
    field: 'Actions',
    width: 200,
    renderCell: cellValues =>
      actionRenderer(cellValues, onEditRow, onDeleteRow),
  },
]
export {
  GetBannerTableColumns,
  GetChapterTableColumns,
  GetCourseTableColumns,
  GetExerciseDetailSubSetColumns,
  GetExerciseDetailTableColumns,
  GetExerciseMasterTableColumns,
  GetFeedbacksColumns,
  GetLessonTableColumns,
  GetLessonVideoTableColumns,
  GetLessonVocabularyTableColumns,
  GetNotificationsColumns,
  GetReportsColumns,
  GetServiceLogColumns,
  GetUnitTableColumns,
  GetUserTableColumns,
  GetVideoCategoryColumns
}
